import React, { FunctionComponent, ReactNode } from 'react';
import { Item } from './SearchParamsItem.style';

type Props = {
  className?: string;
  parentWidth?: number;
  children?: ReactNode;
};

export const SearchParamsItem: FunctionComponent<Props> = ({ children, className, ...rest }) => {
  return (
    <Item className={className} {...rest}>
      {children}
    </Item>
  );
};
